import { createMutation } from "@/api/utils/createMutation";
import {
    Draft,
    DraftEdits,
    DraftSnapshot,
    DraftStatus,
    DraftValidation,
} from "./Draft.model";
import { parseDraft } from "./dummies/DataAssociation.parsers";

export const createDraft = createMutation<Draft, { fileId: string }>(
    async ({ api, router, queryClient, payload }) => {
        const response = await api
            .post(`/data-association/files/${payload.fileId}/draft`)
            .then(parseDraft);
        queryClient.setQueryData(
            [
                `/data-association/drafts?company_id=in.("${router.params.companyId}")`,
            ],
            (old: DraftSnapshot[]) => {
                const newDraft: DraftSnapshot = {
                    id: response.id,
                    status: DraftStatus.IN_PROGRESS,
                    fileId: response.fileId,
                    createdBy: response.ownerId || "",
                    createdAt: response.createdAt,
                };
                return [...old, newDraft];
            },
        );
        return response;
    },
    { invalidates: ["/data-association", "/file"] },
);

export const validateDraft = createMutation<
    DraftValidation,
    {
        draft: DraftEdits;
    }
>(async ({ api, router, payload }) => {
    return api.post(
        `/data-association/files/${router.params.fileId}/drafts/${router.params.draftId}/commit/validate`,
        payload.draft,
    );
});

export const commitDraft = createMutation<
    Draft,
    {
        draft: DraftEdits;
    }
>(
    async ({ api, router, payload, queryClient }) => {
        const response = await api
            .post(
                `/data-association/files/${router.params.fileId}/drafts/${router.params.draftId}/commit`,
                payload.draft,
            )
            .then(parseDraft);

        queryClient.setQueryData(
            [
                `/data-association/drafts?company_id=in.("${router.params.companyId}")`,
            ],
            (old: DraftSnapshot[]) => {
                return old.map((draft) => {
                    if (draft.id === response.id) {
                        return {
                            ...draft,
                            status: DraftStatus.COMMITTED,
                        };
                    }
                    return draft;
                });
            },
        );

        return response;
    },
    {
        invalidates: ["/data-association", "/file"],
        errorToast: {
            message: "Commit failed",
            options: {
                description: "Something went wrong while committing the draft",
            },
        },
    },
);
